import Flex from '../../generic/Flex';
import Icon, { icons } from '../../generic/Icon';
import type { FossaSubscriptionWithPlanName } from '../../../../shared/subscriptions';

type SubscriptionPathProps = {
  oldPlan: FossaSubscriptionWithPlanName;
  newPlan: FossaSubscriptionWithPlanName;
  hidePrices?: boolean;
};

export const renderPriceString = (price: number, dev = false) => {
  if (price === 0) {
    return 'No Cost';
  }

  return `$${price}/month${dev ? '/developer' : ''}`;
};

/**
 * Utility component to create the visual plan upgrade path
 * ie. Free -> Business: Compliance - Security
 *
 * @param {SubscriptionPathProps} props - Component props.
 * @param {FossaSubscriptionWithPlanName} props.oldPlan - Old plan that user is upgrading from
 * @param {FossaSubscriptionWithPlanName} props.newPlan - New plan that user is upgrading to
 * @param {boolean} props.hidePrices - Optional, hides the price if true.
 */
const SubscriptionPath = ({
  oldPlan,
  newPlan,
  hidePrices = false,
}: SubscriptionPathProps) => (
  <div className="subscription-path">
    <header className="plan-header">
      <Flex justify="normal" gap="2em">
        <div>
          <div className="plan-title">
            <span>{oldPlan.label}</span> {oldPlan.description}
          </div>
          {!hidePrices && (
            <span className="plan-price">
              {renderPriceString(oldPlan.price, true)}
            </span>
          )}
        </div>
        <Icon icon={icons.arrowRight} />
        <div>
          <div className="plan-title">
            <span>{newPlan.label}</span> {newPlan.description}
          </div>
          {!hidePrices && (
            <span className="plan-price">
              {renderPriceString(newPlan.price, true)}
            </span>
          )}
        </div>
      </Flex>
    </header>
  </div>
);

export default SubscriptionPath;
